var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CompanyApi } from '@ClientApi/company';
export function signupForEmburseCards(company, user) {
    return __awaiter(this, void 0, void 0, function* () {
        const connections = yield CompanyApi.getCompanyGatewayConnections(company.id);
        //Check if company is created in Gateway to apply for Emburse Cards
        //Connections could return an array with null value hence checking for length and null value
        if (connections.length === 0 || (connections.length === 1 && connections[0] === null)) {
            yield CompanyApi.signupForEmburseCards(company, user);
        }
    });
}
export function redirectToEmburse(companyId) {
    const path = "/";
    const queryParams = `path=${path}&company_id=${companyId}`;
    const windowFeatures = 'top=80,left=80,width=900,height=650';
    window.open(`/go-to-emburse?${queryParams}`, 'popup', windowFeatures);
}
